// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap';

export default class InfographicCirclesController extends AdvancedController {

  static targets = [ 
  ];

  static values = {
  }

  circle1;
  circle2;
  circle3;
  circle4;

  text1;
  text2;
  text3;
  text4;

  icon1;
  icon2;
  icon3;
  icon4;

  stroke1;
  stroke2;
  stroke3;
  stroke4;

  subtext1;
  subtext2;
  subtext3;
  subtext4;

  connect() {
    super.connect(...arguments)

    this.circle1 = document.getElementById("Ring-Gold")
    this.circle2 = document.getElementById("Ring-Green")
    this.circle3 = document.getElementById("Ring-Blue")
    this.circle4 = document.getElementById("Ring-Rose")

    this.text1 = document.getElementById("Text-Gold")
    this.text2 = document.getElementById("Text-Green")
    this.text3 = document.getElementById("Text-Blue")
    this.text4 = document.getElementById("Text-Rose")

    this.icon1 = document.getElementById("Icon-Gold")
    this.icon2 = document.getElementById("Icon-Green")
    this.icon3 = document.getElementById("Icon-Blue")
    this.icon4 = document.getElementById("Icon-Rose")

    this.stroke1 = document.getElementById("Stroke-Gold")
    this.stroke2 = document.getElementById("Stroke-Green")
    this.stroke3 = document.getElementById("Stroke-Blue")
    this.stroke4 = document.getElementById("Stroke-Rose")

    this.subtext1 = document.getElementById("Subtext-Gold")
    this.subtext2 = document.getElementById("Subtext-Green")
    this.subtext3 = document.getElementById("Subtext-Blue")
    this.subtext4 = document.getElementById("Subtext-Rose")

    const len = this.circle1.getTotalLength(); 
    this.circle1.style.strokeDasharray = len;
    this.circle1.style.strokeDashoffset = len;
  }
  
  /* General Sequence: 
  1. Ring
  2. Inner Text + Icon
  3. Stroke
  4. Outer Text
  */
 inViewport() {
    let tl = gsap.timeline();

    // RING 1
    tl.to(this.circle1, {
        strokeDashoffset: 0,
        opacity: 1,
        duration: 2,
      })
      .to(this.text1, {
        opacity: 1,
        duration: 1,
      },
      "<0.5")
      .to(this.icon1, {
        opacity: 1,
        duration: 1,
      },
      "<")
      tl.to(this.stroke1, {
        strokeDashoffset: 0,
      },
      "<1")
      tl.to(this.subtext1, {
        opacity: 1
      },
      "<0.5")

      // RING 2
      .to(this.circle2, {
        strokeDashoffset: 0,
        duration: 2,
        opacity: 1,
        delay: .5,
      },
      "<")
      .to(this.text2, {
        opacity: 1,
        duration: 1,
      },
      "<0.5")
      .to(this.icon2, {
        opacity: 1,
        duration: 1,
      },
      "<")
      tl.to(this.stroke2, {
        strokeDashoffset: 2000,
      },
      "<1")
      tl.to(this.subtext2, {
        opacity: 1
      },
      "<0.5")

      // RING 3
      .to(this.circle3, {
        strokeDashoffset: 0,
        opacity: 1,
        duration: 2,
        delay: .5,
      })
      .to(this.text3, {
        opacity: 1,
        duration: 1,
      },
      "<0.5")
      .to(this.icon3, {
        opacity: 1,
        duration: 1,
      },
      "<")
      tl.to(this.stroke3, {
        strokeDashoffset: 0,
      },
      "<1")
      tl.to(this.subtext3, {
        opacity: 1
      },
      "<0.5")

      // RING 4
      .to(this.circle4, {
        strokeDashoffset: 0,
        opacity: 1,
        duration: 2,
        delay: .5,
      })
      .to(this.text4, {
        opacity: 1,
        duration: 1,
      },
      "<0.5")
      .to(this.icon4, {
        opacity: 1,
        duration: 1,
      },
      "<")
      tl.to(this.stroke4, {
        strokeDashoffset: 2000,
      },
      "<1")
      tl.to(this.subtext4, {
        opacity: 1
      },
      "<0.5")
  }
}
